import React, { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, Input, Select } from 'src/common';
import styles from '../index.module.scss';
import { COUNTRIES } from 'src/helpers/constants';
import { Translations } from 'src/lib/I18nService/types';
import { useSignUpFlow, SignUpFlow } from 'src/models/auth';
import AuthBack from '../../AuthBack';
import classNames from 'classnames';

export const CompanyInfo: FC = () => {
  const { t } = useTranslation();
  const { t: countryT } = useTranslation(Translations.country);
  const [step, setStep] = useSignUpFlow();
  const onNext = useCallback(() => {
    setStep(SignUpFlow.UserInfo);
  }, [setStep]);
  const countries = useMemo(
    () => [...COUNTRIES].sort((countryA, countryB) => countryT(countryA.key).localeCompare(countryT(countryB.key))),
    [countryT]
  );

  return (
    <div className={classNames(styles.step, { [styles.isActive]: step === SignUpFlow.CompanyInfo })}>
      <div className={styles.heading}>
        <h3 className={styles.title}>
          <span>{t('Auth.signUp.title')}</span>
        </h3>
        <span className={styles.desc}>{t('Auth.signUp.desc')}</span>
      </div>
      <Form.Item
        name={'orgName'}
        label={t('Auth.signUp.labels.orgName')}
        rules={[{ required: true, message: t('Common.inputRequired', { inputName: t('Auth.signUp.labels.orgName') }) }]}
      >
        <Input placeholder={t('Auth.signUp.placeholders.orgName')} autoComplete={'organization'} type={'text'} />
      </Form.Item>
      <Form.Item
        name={'orgNumber'}
        label={t('Auth.signUp.labels.orgNumber')}
        rules={[
          { required: true, message: t('Common.inputRequired', { inputName: t('Auth.signUp.labels.orgNumber') }) }
        ]}
      >
        <Input placeholder={t('Auth.signUp.placeholders.orgNumber')} type={'text'} />
      </Form.Item>
      <Form.Item
        label={t('Auth.signUp.labels.country')}
        name={'country'}
        rules={[{ required: true, message: t('Common.inputRequired', { inputName: t('Auth.signUp.labels.country') }) }]}
      >
        <Select
          style={{ width: '100%' }}
          showSearch={true}
          placeholder={t('Auth.signUp.placeholders.country')}
          optionFilterProp={'title'}
          {...{ autoComplete: 'random-value-to-disable' }}
        >
          {countries.map(country => (
            <Select.Option key={country.key} value={country.key} title={countryT(country.key)}>
              {countryT(country.key)}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name={'address'}
        label={t('Auth.signUp.labels.address')}
        rules={[{ required: true, message: t('Common.inputRequired', { inputName: t('Auth.signUp.labels.address') }) }]}
      >
        <Input placeholder={t('Auth.signUp.placeholders.address')} type={'text'} />
      </Form.Item>
      <div className={styles.actions}>
        <AuthBack />
        <Button type={'primary'} onClick={onNext}>
          {t('Common.next')}
        </Button>
      </div>
    </div>
  );
};

export default CompanyInfo;
